angular.module('unica_agenda.agenda_controllers')

.controller('AgendaListController',
	function(
		$rootScope, $scope, $state, $stateParams,
		AgendaService,
		TASK_TYPES
	) {

	$scope.taskTypes = TASK_TYPES;

	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventStages( $stateParams.event_id );

});
